import { render } from "./Messages.vue?vue&type=template&id=b811de0e&scoped=true"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"

import "./Messages.vue?vue&type=style&index=0&id=b811de0e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/medsien-patient-app/medsien-patient-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b811de0e"]])

export default __exports__